export enum unsubscribeStateTypes {
  CONFIRM = 'confirm',
  CANCELLED = 'cancelled',
  INVALID = 'invalid',
}
